import { render, staticRenderFns } from "./RelatedLinks.vue?vue&type=template&id=1d78d343"
import script from "./RelatedLinks.vue?vue&type=script&lang=js"
export * from "./RelatedLinks.vue?vue&type=script&lang=js"
import style0 from "./RelatedLinks.vue?vue&type=style&index=0&id=1d78d343&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports